import { Box, Divider, Loader, SectionHelper } from '@wix/design-system';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { SwitchProductModule } from '../../switch-product.module';
import { FeaturesNamespace } from './FeaturesNamespace';
export const PlanFeaturesModalContent = () => {
  var _currentProductData$c, _featuresGridData$nam, _currentProductData$c2;
  const {
    Trans
  } = SwitchProductModule.internals.useTranslations();
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const {
    data: currentProductData,
    isLoading: isCurrentProductLoading
  } = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const productId = (currentProductData == null || (_currentProductData$c = currentProductData.currentProduct) == null ? void 0 : _currentProductData$c.productId) ?? '';
  const shouldShowSectionHelper = !(currentProductData != null && currentProductData.isCurrentProductFamilyInOffering) && !(currentProductData != null && currentProductData.isCurrentProductInOffering);
  const {
    data: featuresGridData,
    isLoading: isFeaturesGridLoading
  } = PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetFeaturesGrid({
    productIds: [productId],
    ...p3Context
  }, !isCurrentProductLoading && !!productId);
  const isLoading = isFeaturesGridLoading || isCurrentProductLoading;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Box, {
      align: "center",
      height: "100%"
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, featuresGridData == null || (_featuresGridData$nam = featuresGridData.namespaces) == null ? void 0 : _featuresGridData$nam.filter(ns => {
    var _ns$features;
    return (_ns$features = ns.features) == null ? void 0 : _ns$features.some(feature => {
      var _feature$values;
      return (_feature$values = feature.values) == null || (_feature$values = _feature$values[productId]) == null ? void 0 : _feature$values.available;
    });
  }).map((ns, index, filtered) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: ns.id
  }, /*#__PURE__*/React.createElement(FeaturesNamespace, {
    key: ns.id,
    namespace: ns,
    productId: productId
  }), index < filtered.length - 1 && /*#__PURE__*/React.createElement(Divider, {
    key: `divider-${index}`
  })))), shouldShowSectionHelper && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SectionHelper, {
    skin: "standard"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "change_plan.current_plan_modal.explanation_advanced",
    values: {
      planName: currentProductData == null || (_currentProductData$c2 = currentProductData.currentProduct) == null ? void 0 : _currentProductData$c2.productName
    },
    components: [/*#__PURE__*/React.createElement("strong", null)]
  }))));
};
//# sourceMappingURL=PlanFeaturesModalContent.js.map